<template>
    <div class="vx-col md:w-full sm:w-auto">
        <div class="vx-row md:w-full">
            <vx-tooltip class="position-icon" :text="$t('navMenu.personnel')" position="top" v-if="isRouterEmployee()">
                <feather-icon icon="UsersIcon" class="action-success icon-btn"
                              svgClasses="h-5 w-5 hover:text-primary cursor-pointer"
                              @click="manageEmployee"/>
            </vx-tooltip>

            <vx-tooltip class="position-icon" :text="$t('button.details')" position="top" v-if="isPermissionUpdate()">
                <feather-icon icon="EyeIcon" class="action-success icon-btn"
                              svgClasses="h-5 w-5 hover:text-primary cursor-pointer"
                              @click="editRecord"/>
            </vx-tooltip>

            <vx-tooltip class="position-icon" :text="$t('button.delete')" position="top" v-if="isPermissionDelete()">
                <feather-icon icon="TrashIcon" class="action-err icon-btn"
                              svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
                              @click="confirmDeleteRecord"/>
            </vx-tooltip>
        </div>

<!--        <vs-popup class="holamundo"  title="Thông tin chi nhánh" :active.sync="openBranchDetails" v-if="openBranchDetails" id="details-branch">-->
<!--            <BranchInformation :branchId="params.data.id"></BranchInformation>-->
<!--        </vs-popup>-->
    </div>
</template>

<script>
import {isAPI, isRouter} from "../../../../store/permission";
import {constAPI, constRouter} from "../../../../store/constant";
// import BranchInformation from "../BranchInformation";

export default {
    name: 'CellRendererActions',
    components: {
        // BranchInformation
    },
    data() {
        return {
            openBranchDetails: false
        }
    },
    methods: {
        isRouterEmployee(){
            return isRouter(this, constRouter.employee_all);
        },
        isPermissionDelete(){
            return isAPI(this, constAPI.organization_branch_delete);
        },
        isPermissionUpdate(){
            return isAPI(this, constAPI.organization_branch_edit);
        },
        manageEmployee() {
            this.$router.push(`/user/manage-employee?branch_id=${this.params.data.id}`).catch(() => {
            })
        },
        editRecord() {
            // this.openBranchDetails = true;
            this.$router.push(`/user/edit-organization-branch?branch_id=${this.params.data.id}`).catch(() => {
            })
        },

        confirmDeleteRecord() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Xác nhận xoá`,
                text: `Bạn có chắc là muốn xoá chi nhánh "${this.params.data.organizationBranchName}" không ?`,
                accept: this.deleteRecord,
                acceptText: "Xoá",
                cancelText: "Huỷ"
            })
        },

        deleteRecord() {
            this.$vs.loading();
            this.$crm.post(`/organization-branch/delete/${this.params.data.id}`).then(() => {
                this.$vs.loading.close();
                return this.showDeleteSuccess();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        showDeleteSuccess() {
            this.$store.commit('DELETE_BRANCH_STATUS', true);
            this.$vs.notify({
                color: 'success',
                text: 'Xoá chi nhánh thành công',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
            })
        }
    },

    mounted() {
        this.$eventBus.$on('update-branch-success', () => {
            this.openBranchDetails = false;
        })
    }
}
</script>

<style lang="scss">
#details-branch {
    .vs-popup {
        width: 1400px !important;
    }
}
</style>
